<script>
  import Icon from './Icon.svelte'
</script>

<div class="credits">
  <div class="produced">Produced for The Outlier by</div>
  <div class="authors">
    <a href="https://twitter.com/RichGemma" target="_blank">Gemma Ritchie</a>,
    <a href="https://twitter.com/gemma_gatticchi" target="_blank"
      >Gemma Gatticchi</a
    >,
    <a href="https://twitter.com/LauraJGrant" target="_blank">Laura Grant</a> &
    <a href="https://twitter.com/alastairotter" target="_blank"
      >Alastair Otter</a
    >
    <br />
    Drone footage by Joshua Rubin<br />
    23 December 2021<br />
  </div>
  <div class="spacer">&nbsp;</div>
  Contact us: 📨 &nbsp;<a href="mailto:info@theoutlier.co.za"
    >info@theoutlier.co.za</a
  >
  <div class="spacer">&nbsp;</div>
  <div class="newsletter-promo">
    <a href="https://twitter.com/outlierafrica" target="_blank"
      >Follow us for more<br />
      <img src="/images/twitter.svg" alt="Twitter Icon" /></a
    >
    <p>
      See more like this by signing up for our
      <a href="https://newsletter.theoutlier.co.za" target="_blank"
        >newsletter</a
      >.
    </p>
  </div>
  <div class="signupform">
    <form
      class="js-cm-form"
      id="subForm"
      action="https://www.createsend.com/t/subscribeerror?description="
      method="post"
      data-id="92D4C54F0FEC16E5ADC2B1904DE9ED1AAA5D68D26FD222ECE64C6A563A9BF339160E857807618A1E6614A43A746C409629B4C258EC846CC82657DA43FB662EAD"
    >
      <label>Email Address: </label><br /><input
        autocomplete="Email"
        aria-label="Email"
        class="js-cm-email-input qa-input-email"
        id="fieldEmail"
        maxlength="200"
        name="cm-jtdujtk-jtdujtk"
        required=""
        type="email"
        placeholder="name@email.com"
      />
      <br /><input
        type="hidden"
        aria-label="Signup source"
        id="fieldjthyqu"
        maxlength="200"
        name="cm-f-jthyqu"
        value="henry-nxumalo-looting"
      /><button type="submit">Subscribe</button>
    </form>
    <script
      type="text/javascript"
      src="https://js.createsend1.com/javascript/copypastesubscribeformlogic.js"></script>
  </div>

  <div class="spacer">&nbsp;</div>
  <div class="produced">
    Supported by<br />
    <a href="https://henrynxumalofoundation.co.za/" target="_blank">
      <br />
      <img
        src="/images/henrynxumalo.png"
        alt="Henry Nxumalo Foundation Logo"
      /></a
    >
  </div>
</div>

<style>
  .signupform {
    width: 100%;
    text-align: center;
  }
  .produced {
    font-weight: 700;
    font-size: 1.2rem;
    font-family: var(--titleFont);
  }
  .produced img {
    width: 250px;
  }
  .newsletter-promo img {
    width: 30px;
  }
  .newsletter-promo a {
    text-decoration: none;
  }
  label {
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 700;
  }
  button {
    padding: 10px 20px;
    border-radius: 50px;
    margin-top: 10px;
    background: hotpink;
    border: none;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
  }
  button:hover {
    background: rgb(255, 46, 151);
  }
  input {
    padding: 10px;
    background: #313131;
    border: solid 1px gray;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 300px;
    color: #fff;
    text-align: center;
  }
  .credits {
    max-width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
</style>
